import { AuthenticatedTemplate } from "@azure/msal-react";
import { Row, Col, Button } from "react-bootstrap";
import React from "react";
import { IHeader } from "./Interfaces";
import "./css/Header.css";
import { headerPath } from "../../common/PathConstants";

function Header({ pages, setPage }: IHeader) {
  const handleLogoutOnClick = (e: React.MouseEvent<HTMLElement>) => {
    setPage(pages[e.currentTarget?.id]);
  };
  const handleHomeOnClick = () => {
    window.location.href = "/";
  };
  const mainPageLogoLink = (
    <img
      id="mainPageKey"
      src={headerPath}
      alt="logo"
      className="custom-img"
      onClick={handleHomeOnClick}
    />
  );

  return (
    <Row className="align-items-center">
      <Col className="text-left">{mainPageLogoLink}</Col>
      <Col className="text-center">
        <Row>
          <div className="title">SIM Documents {process.env.REACT_APP_ENV == "PRD" ? "" : process.env.REACT_APP_ENV}</div>
        </Row>
      </Col>
      <Col className="d-flex justify-content-end">
        <AuthenticatedTemplate>
          <Button id="logoutPageKey" onClick={handleLogoutOnClick}>
            Logout
          </Button>
        </AuthenticatedTemplate>
      </Col>
      <hr className="separator" />
    </Row>
  );
}

export default Header;
